<template>
  <v-container fluid fill-height align-start ma-0 pa-0>
    <v-row no-gutters class="mt-5">
      <v-col cols="12" class="d-flex">
        <span>작성일자 : {{ createDt ? createDt : '-' }}</span>
        <span style="margin-left: 100px;">수정일자 : {{ updateDt ? updateDt : '-' }}</span>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-form class="pt-3" style="width:100%; height:100%;" ref="form">
        <v-sheet width="100%" height="100%" class="overflow-hidden overflow-y-auto" :key="componentKey">
          <v-row no-gutters>
            <v-col cols="12" md="12" lg="10" class="pt-0">
              <v-tooltip right color="primary" max-width="500px">
                <template v-slot:activator="{ on }">
                  <span class="editor-label">
                    <span>{{ '1. 제목' }}</span>
                    <svg-icon icon-class="info" class="ml-1" style="height: 1rem" v-on="on" />
                  </span>
                </template>
                <div class="tooltip-text">{{ '안전보건경영 관리 문서의 제목, 출력 시 문서 최상단에 표시됩니다.' }}</div>
              </v-tooltip>
              <v-text-field
                style="width: 100%;"
                v-model="params.contentHeader"
                solo
                class="editor_bg"
                placeholder="안전보건경영 방침의 제목을 입력하세요."
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12" lg="10" class="pt-5">
              <span class="editor-label">{{ '2. 내용' }}</span>
              <v-textarea
                style="width: 100%;"
                v-model="params.contentBody"
                spellcheck="false"
                no-resize
                rows="5"
                row-height="40"
                solo
                class="editor_bg"
                auto-grow
                placeholder="안전보건경영 방침의 내용을 입력하세요."
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="12" lg="10" class="pt-5">
              <span class="editor-label">{{ '3. 안전보건목표' }}</span>
              <v-textarea
                style="width: 100%;"
                v-model="params.contentObject"
                spellcheck="false"
                no-resize
                rows="5"
                row-height="20"
                solo
                class="editor_bg"
                auto-grow
                placeholder="안전보건목표를 입력하세요."
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="12" lg="10" class="pt-5">
              <v-tooltip right color="primary" max-width="500px">
                <template v-slot:activator="{ on }">
                  <span class="editor-label">
                    <span class="editor-label">{{ '4. 추진계획' }}</span>
                    <svg-icon icon-class="info" class="ml-1" style="height: 1rem" v-on="on" />
                  </span>
                </template>
                <div class="tooltip-text">{{ '성과측정 및 실적관리에 필요한 추진계획을 입력하세요.' }}</div>
              </v-tooltip>
              <v-card width="100%" v-for="(plan, planIndex) in planList" :key="'plan_' + planIndex" class="d-flex mt-2">
                <div class="ma-1 d-flex justify-center align-center">
                  <v-btn small text icon @click="removePlan(planIndex)">
                    <svg-icon icon-class="minus" style="height:20px" />
                  </v-btn>
                </div>
                <v-expansion-panels v-model="expandedPanel[planIndex]" accordion>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div class="d-flex align-center required" style="width:5%;">목표</div>
                      <v-text-field
                        style="width: 100%;"
                        v-model="plan.objectNm"
                        solo
                        class="editor_bg"
                        :rules="[rules.required]"
                        placeholder="추진계획의 목표를 입력하세요."
                      ></v-text-field>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card v-for="(object, objectIndex) in plan.objects" :key="'object_' + objectIndex" class="addable-card d-flex mt-2">
                        <div v-if="plan.objects.length > 1" class="d-flex justify-center align-center">
                          <v-btn text small @click="removeDiv(plan, objectIndex)" height="calc(100% - 24px)" class="rounded-pill" :color="'error'">
                            <svg-icon icon-class="minus" style="height:20px" />
                          </v-btn>
                        </div>
                        <v-card width="100%" class="pa-4" :class="plan.objects.length > 1 ? 'addable-contents' : ''">
                          <v-simple-table class="custom-table">
                            <template v-slot:default>
                              <tbody>
                                <tr>
                                  <td class="text-center tableTitle required">구분</td>
                                  <td style="border-bottom: thin solid rgba(0, 0, 0, 0.12);">
                                    <v-text-field
                                      style="width: 100%;"
                                      v-model="object.divNm"
                                      solo
                                      class="editor_bg"
                                      :rules="[rules.required]"
                                      placeholder="추진계획의 목표에 따른 구분을 입력하세요."
                                    ></v-text-field>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="text-center tableTitle required">내용</td>
                                  <td style="border-bottom: thin solid rgba(0, 0, 0, 0.12);">
                                    <v-text-field
                                      style="width: 100%;"
                                      v-model="object.divContent"
                                      solo
                                      class="editor_bg"
                                      :rules="[rules.required]"
                                      placeholder="추진계획의 목표 구분에 따른 내용을 입력하세요."
                                    ></v-text-field>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card>
                      </v-card>

                      <div class="px-0 pb-0 w-full d-flex justify-center align-center">
                        <v-btn elevation="0" @click="addDiv(plan)" width="100%" height="48" class="table-add-btn">
                          <svg-icon icon-class="table-add" width="20" height="20" />
                        </v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
              <div class="w-full d-flex justify-center align-center mt-2">
                <v-btn elevation="0" @click="addPlan()" width="100%" height="48" class="table-add-btn">
                  <svg-icon icon-class="table-add" width="20" height="20" />
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="12" lg="10" class="pt-5">
              <v-tooltip right color="primary" max-width="500px">
                <template v-slot:activator="{ on }">
                  <span class="editor-label">
                    <span>{{ '5. 하단' }}</span>
                    <svg-icon icon-class="info" class="ml-1" style="height: 1rem" v-on="on" />
                  </span>
                </template>
                <div class="tooltip-text">{{ '효력발생일자 등, 출력 시 문서 최하단에 표시됩니다.' }}</div>
              </v-tooltip>
              <v-textarea
                class="editor_bg"
                style="width: 100%;"
                v-model="params.contentFooter"
                spellcheck="false"
                rows="5"
                row-height="20"
                no-resize
                solo
                auto-grow
                placeholder="효력발생일자 등 문서 최하단에 표시할 내용을 입력하세요."
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="12" lg="10" class="pt-5" :class="{ 'guide-blink-target': guideHighlight }">
              <iFileManage
                ref="detailFileUpload"
                :targetId="params.clntId + '_' + params.dataType"
                targetType="00005"
                @onFileChanged="onFileChanged"
                :fileExtension="'.pdf'"
                :maxFileCount="1"
                :titleDesc="'대시보드에 사용될 pdf 파일 1개만 업로드가 가능합니다.'"
              />
            </v-col>
          </v-row>
        </v-sheet>
      </v-form>
    </v-row>
    <i-dxpopup
      v-if="signPopupVisible"
      :popupVisible="signPopupVisible"
      @popupCloseButtonClick="popupCloseButtonClick"
      title="서명 등록"
      :vHtmlContent="'test'"
      height="400"
      width="500"
    >
      <template v-slot:grid>
        <editSign @signPopupClosed="signPopupClosed($event)"></editSign>
      </template>
    </i-dxpopup>
  </v-container>
</template>

<script>
// 공통 컴포넌트
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import _ from 'lodash'
import { getCurrentDate } from '@/utils/common.js'
import iDxPopup from '@/components/common/iDxPopup.vue'
import editSign from '@/components/sign/editSign.vue'
// API
import { getSHManageData, getSHSampleData, saveSHManageData, getCeoSignature } from '@/api/leaderShip/shManagePolicy_new'
import { getUserListInfo } from '@/api/system/userManage'
import { getGrpAuthCd } from '@/utils/token'
import iFileManage from '@/components/esgCommon/iFileManage.vue'

export default {
  mixins: [baseview],
  components: {
    editSign,
    'i-dxpopup': iDxPopup,
    iFileManage
  },
  props: {
    datasource: {
      type: Object,
      default: () => {}
    },
    guideHighlight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      buttonUseList: [
        'btnSave' // 저장
      ],
      componentKey: 0,
      params: {
        // clntId: this.getClntId(),
        // compId: this.getCompId(),
        // dataType: '00002',
        // contentHeader: '',
        // contentBody: '',
        // contentFooter: ''
      },
      createDt: '',
      updateDt: '',
      signPopupVisible: false,
      expandedPanel: [],
      planList: [],
      fileList: [],
      canNotSave: false, // 파일 오류 상태값
      rules: {
        required: value => !!value || '필수 입력 사항입니다.'
      }
    }
  },
  watch: {
    datasource: {
      deep: true,
      handler() {
        // 데이터 바인딩
        this.dataInit()
      }
    }
  },
  computed: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.dataInit()
  },
  activated() {},
  methods: {
    searchFile() {
      this.$refs.detailFileUpload.btnSearch()
    },
    dataInit() {
      // 테이터 초기 세팅
      this.params = _.cloneDeep(this.datasource)
      if (Object.keys(this.params).length == 0) {
        ;(this.params.clntId = this.getClntId()),
          (this.params.compId = this.getCompId()),
          (this.params.dataType = '00002'),
          (this.params.__created__ = true)
      }
      this.planList = this.datasource.planList ? _.cloneDeep(this.datasource.planList) : []
      this.createDt = this.params.createdAt ? this.params.createdAt.substr(0, 19).replaceAll('-', '.') : ''
      this.updateDt = this.params.updatedAt ? this.params.updatedAt.substr(0, 19).replaceAll('-', '.') : ''
    },
    btnSampleLoad() {
      // 예시 보기
      console.log('## 예시보기 클릭')
      this.vToastifyPrompt(this.$t('작성중인 내용이 덮어집니다. 예시를 불러오시겠습니까?'), 'info', async current => {
        this.openLoading()
        // API
        getSHSampleData({ clntId: this.getClntId() }, true)
          .then(res => {
            console.log('#Res', res)
            this.params.contentHeader = res.contentHeader
            this.params.contentBody = res.contentBody
            this.params.contentObject = res.contentObject
            this.params.contentFooter = res.contentFooter
            this.planList = res.planList
            this.componentKey++
            this.endLoading()
          })
          .catch(e => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
        return
      })
    },
    async btnSave() {
      if (!this.$refs.form.validate()) {
        //
        this.vSnackbar(this.$t('저장 입력 항목을 확인해주세요.'), 'warn', 3000)
        return
      }
      if (this.canNotSave) {
        // 파일 오류가 있을때
        this.vSnackbar(this.$t('하나의 pdf 파일만 업로드 가능합니다.'), 'warn', 3000)
        return
      }
      await getCeoSignature({ clntId: this.getClntId() })
        .then(res => {
          if (res.success) {
            if (res.list.length == 0 || res.list[0] == null) {
              if (getGrpAuthCd() == 'ceo') {
                this.vSnackbar(this.$t('서명 등록이 필요합니다.'), 'warn', 1000)
                this.signPopupVisible = true
              } else {
                this.vSnackbar(this.$t('경영책임자의 서명이 없어 저장이 불가합니다.'), 'warn', 1000)
                return
              }
            } else {
              // 저장
              this.vToastifyPrompt(
                this.$t('저장하시겠습니까?'),
                'info',
                async current => {
                  const lastTenCharsBody = this.params.contentBody.slice(-10)
                  // 줄바꿈 문자가 있는지 확인
                  if (lastTenCharsBody.includes('\n')) {
                    // 마지막 10번째까지의 문자열에서 공백 문자 제거
                    this.params.contentBody = this.params.contentBody.slice(0, -10) + lastTenCharsBody.trim()
                  }
                  const lastTenCharsObject = this.params.contentObject.slice(-10)
                  // 줄바꿈 문자가 있는지 확인
                  if (lastTenCharsObject.includes('\n')) {
                    // 마지막 10번째까지의 문자열에서 공백 문자 제거
                    this.params.contentObject = this.params.contentObject.slice(0, -10) + lastTenCharsObject.trim()
                  }
                  // const lastTenCharsFooter = this.params.contentFooter.slice(-10)
                  // if (lastTenCharsFooter.includes('\n')) {
                  //   // 마지막 10번째까지의 문자열에서 공백 문자 제거
                  //   this.params.contentFooter = this.params.contentFooter.slice(0, -10) + lastTenCharsFooter.trim()
                  // }
                  this.params.planList = this.planList
                  this.openLoading()
                  let saveSuccess = false
                  saveSHManageData(this.params, true)
                    .then(res => {
                      saveSuccess = true
                      // this.updateDt = getCurrentDate().replaceAll('-', '.')
                      this.params.__created__ = false
                    })
                    .catch(e => {
                      this.endLoading()
                    })
                    .finally(() => {
                      if (saveSuccess && (this.fileList.insert || this.fileList.delete)) {
                        this.$refs.detailFileUpload.btnSave(this.fileList)
                        this.fileList = {
                          insert: [],
                          delete: []
                        }
                      }
                      this.endLoading()
                      getSHManageData({ clntId: this.getClntId(), dataType: '00002' }, false).then(res => {
                        this.params = res.clntId ? res : {}
                        this.updateDt = this.params.updatedAt ? this.params.updatedAt.substr(0, 19).replaceAll('-', '.') : ''
                      })
                    })
                },
                null,
                true
              )
            }
          }
        })
        .catch(error => {
          //////console.log(error)
        })
    },
    popupCloseButtonClick() {
      this.signPopupVisible = false
    },
    signPopupClosed(savedData) {
      if (savedData.updateSign) {
        this.btnSave()
      }
      this.signPopupVisible = false
    },
    // 추진 계획
    addDiv(plan) {
      console.log('@@ plan', plan)
      let dataset = {
        divNm: '',
        divContent: ''
      }
      plan.objects.push(dataset)
    },
    removeDiv(plan, objectIndex) {
      plan.objects.splice(objectIndex, 1)
    },
    addPlan() {
      let dataset = {
        objectNm: '',
        objects: [
          {
            divNm: '',
            divContent: ''
          }
        ]
      }
      this.planList.push(dataset)
      // this.expandedPanel.push(0)
    },
    removePlan(planIndex) {
      this.planList.splice(planIndex, 1)
    },
    onFileChanged(fileList) {
      console.log('########### fileList', fileList)
      if (fileList.insert.length > 1) {
        // 파일이 하나 이상일 때
        this.vSnackbar(this.$t('하나의 pdf 파일만 업로드 가능합니다.'), 'warn', 3000)
        this.canNotSave = true
        return
      }
      if (fileList.insert.length > 0 && fileList.insert[0]?.extension !== 'pdf') {
        // 파일이 pdf 타입이 아닐 때
        this.vSnackbar(this.$t('하나의 pdf 파일만 업로드 가능합니다.'), 'warn', 3000)
        this.canNotSave = true
        return
      }
      this.canNotSave = false
      this.fileList = fileList
    }
  }
}
</script>

<style lang="scss"></style>
